webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leancloud_storage__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leancloud_storage__);
/**
 * @Author: Hexon
 * @Date: 2017/8/21 11:25
 * @Last Modified by: Hexon
 * @Last Modified time: 2017/8/21 11:25
 */


var APP_ID = 'g6v3366pjyTJndsKm1pGPQRq-gzGzoHsz';
var APP_KEY = 'WEwj90I8fmYJrYdW5QaHSqa9';

__WEBPACK_IMPORTED_MODULE_0_leancloud_storage___default.a.init({
  appId: APP_ID,
  appKey: APP_KEY
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_leancloud_storage___default.a);

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__ = __webpack_require__(16);
/**
 * @Author: Hexon
 * @Date: 2017/8/21 12:25
 * @Last Modified by: Hexon
 * @Last Modified time: 2017/8/21 12:25
 */



/* harmony default export */ __webpack_exports__["a"] = (function (user) {
  var _ref = user || __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__["a" /* default */].User.current() || { attributes: {} },
      id = _ref.id,
      username = _ref.attributes.username;

  return {
    id: id || '',
    username: username || '' };
});

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @Author: Hexon
 * @Date: 2017/8/21 11:45
 * @Last Modified by: Hexon
 * @Last Modified time: 2017/8/21 11:45
 */
var map = {
  202: '用户名已被占用',
  210: '用户名和密码不匹配',
  211: '找不到该用户',
  217: '无效的用户名',
  unknown: '请求失败，请稍后再试'
};

/* harmony default export */ __webpack_exports__["a"] = (function (code) {

  return map[code] || map.unknown;
});

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports) {



/***/ }),
/* 71 */,
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(192),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_reset_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Topbar__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Topbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Topbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Editor__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Preview__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_index__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_leancloud__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_getAVUser__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      previewMode: false
    };
  },

  name: 'app',
  methods: {
    preview: function preview() {
      console.log('hhh');
      this.previewMode = true;
    },
    exitPreview: function exitPreview() {
      this.previewMode = false;
    }
  },
  // 导入store，它会被注入所有子组件中
  store: __WEBPACK_IMPORTED_MODULE_6__store_index__["a" /* default */],
  components: { Topbar: __WEBPACK_IMPORTED_MODULE_2__components_Topbar___default.a, Editor: __WEBPACK_IMPORTED_MODULE_3__components_Editor___default.a, Preview: __WEBPACK_IMPORTED_MODULE_4__components_Preview___default.a },
  created: function created() {
    document.body.insertAdjacentHTML('afterbegin', __WEBPACK_IMPORTED_MODULE_5__assets_icons__["a" /* default */]);
    var state = localStorage.getItem('state');
    if (state) {
      state = JSON.parse(state);
    }
    this.$store.commit('initState', state);
    this.$store.commit('setUser', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_getAVUser__["a" /* default */])());
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['items', 'labels', 'title'],
  computed: {
    // keys 其实是一个计算属性
    keys: function keys() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.items[0]);
    }
  },
  methods: {
    addItems: function addItems() {
      var empty = {};
      // 所以在此处使用的是keys，而不是keys()
      this.keys.map(function (key) {
        empty[key] = '';
      });
      this.items.push(empty);
    },
    removeItems: function removeItems(index) {
      this.items.splice(index, 1);
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileEditor__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProfileEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ArrayEditor__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ArrayEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ArrayEditor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ProfileEditor: __WEBPACK_IMPORTED_MODULE_0__ProfileEditor___default.a, ArrayEditor: __WEBPACK_IMPORTED_MODULE_1__ArrayEditor___default.a },
  computed: {
    selected: {
      get: function get() {
        return this.$store.state.selected;
      },
      set: function set(value) {
        return this.$store.commit('switchTab', value);
      }
    },
    resume: function resume() {
      return this.$store.state.resume;
    }
  },
  methods: {
    changeResumeField: function changeResumeField(path, value) {
      console.log(path);
      this.$store.commit('updateResume', {
        path: path,
        value: value
      });
    },
    addItem: function addItem(path) {
      this.$store.commit('addFieldItem', { path: path });
    },
    removeItem: function removeItem(path, index) {
      this.$store.commit('removeFieldItem', { path: path, index: index });
    }
  },
  // created()函数是组件被创建之后的回调函数
  created: function created() {}
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MyDialog',
  props: ['title', 'visible'],
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    filter: function filter(array) {
      var _this = this;

      // 找出非空对象
      return array = array.filter(function (item) {
        return !_this.isEmpty(item);
      });
    },
    isEmpty: function isEmpty(object) {
      // 只要有一个value不是falsy，就返回false
      var empty = true;
      for (var key in object) {
        if (object[key]) {
          empty = false;
          break;
        }
      }
      return empty;
    }
  },
  computed: {
    resume: function resume() {
      console.log('ahhah');
      return this.$store.state.resume;
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bulma__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bulma___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bulma__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { bulma: __WEBPACK_IMPORTED_MODULE_0_bulma___default.a },
  // 这句话表示：我允许从外面接受一个名为profile的变量
  // 就是别的组件向本组件传递数据
  props: ['profile'],
  data: function data() {
    return {
      titles: {
        name: '名字',
        city: '城市',
        birth: '生日'
      }
    };
  },

  computed: {
    resume: function resume() {
      return this.$store.state.resume;
    }
  },
  methods: {
    changeResumeField: function changeResumeField(field, subfield, value) {
      this.$store.commit('updateResume', {
        field: field,
        subfield: subfield,
        value: value
      });
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getErrorMessage__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getAVUser__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SignInForm',
  data: function data() {
    return {
      formData: {
        username: '',
        password: ''
      },
      errorMessage: '',
      formLabelWidth: '120px'
    };
  },

  methods: {
    signIn: function signIn() {
      var _this = this;

      var _formData = this.formData,
          username = _formData.username,
          password = _formData.password;

      __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__["a" /* default */].User.logIn(username, password).then(function () {
        _this.$emit('success', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_getAVUser__["a" /* default */])());
      }, function (error) {
        _this.errorMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_getErrorMessage__["a" /* default */])(error.code);
        _this.open4(_this.errorMessage);
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    open4: function open4(error) {
      this.$message.error(error);
    }
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getErrorMessage__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getAVUser__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SignUpForm',
  data: function data() {
    return {
      formData: {
        username: '',
        password: ''
      },
      errorMessage: ''
    };
  },
  created: function created() {},

  methods: {
    signUp: function signUp() {
      var _this = this;

      var _formData = this.formData,
          username = _formData.username,
          password = _formData.password;

      var user = new __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__["a" /* default */].User();
      user.setUsername(username);
      user.setPassword(password);
      console.log(username);
      console.log(password);
      user.signUp().then(function (loginedUser) {
        _this.$emit('success', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_getAVUser__["a" /* default */])());
      }, function (error) {
        _this.errorMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_getErrorMessage__["a" /* default */])(error.code);

        _this.open4(_this.errorMessage);
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    open4: function open4(error) {
      this.$message.error(error);
    }
  }

});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MyDialog__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignUpForm__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignUpForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SignUpForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SignInForm__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SignInForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SignInForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Topbar',
  data: function data() {
    return {
      signUpDialogVisible: false,
      signInDialogVisible: false
    };
  },

  components: {
    MyDialog: __WEBPACK_IMPORTED_MODULE_0__MyDialog___default.a, SignUpForm: __WEBPACK_IMPORTED_MODULE_2__SignUpForm___default.a, SignInForm: __WEBPACK_IMPORTED_MODULE_3__SignInForm___default.a
  },
  methods: {
    preview: function preview() {
      this.$emit('preview');
    },
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].User.logOut();
      this.$store.commit('removeUser');
    },
    signIn: function signIn(user) {
      this.signUpDialogVisible = false;
      this.signInDialogVisible = false;
      this.$store.commit('setUser', user);
    },
    cancel: function cancel() {
      this.signUpDialogVisible = false;
      this.signInDialogVisible = false;
    }
  },
  computed: {
    user: function user() {
      return this.$store.state.user;
    },
    logined: function logined() {
      return this.user.id;
    }
  }

});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("<svg style=\"display:none\">\n<symbol id=\"icon-add\" width=\"200px\" height=\"200.00px\" viewBox=\"0 0 1024 1024\" ><path d=\"M1000.704728 1023.968001h-139.643636a23.295272 23.295272 0 0 1 0-46.558545h116.348364V861.093091a23.295272 23.295272 0 0 1 46.558545 0v139.643636a23.295272 23.295272 0 0 1-23.263273 23.263273z m0-279.255273a23.295272 23.295272 0 0 1-23.295272-23.295272v-139.611637a23.295272 23.295272 0 0 1 46.558545 0v139.611637a23.295272 23.295272 0 0 1-23.263273 23.295272z m0-279.287273a23.295272 23.295272 0 0 1-23.295272-23.263273V302.550545a23.295272 23.295272 0 0 1 46.558545 0v139.611637a23.295272 23.295272 0 0 1-23.263273 23.263273z m0-279.255273a23.295272 23.295272 0 0 1-23.295272-23.263273V46.558545H861.093091a23.295272 23.295272 0 0 1 0-46.558545h139.643636c12.7996 0 23.263273 10.431674 23.263273 23.263273v139.643636a23.295272 23.295272 0 0 1-23.263273 23.263273zM721.417456 1023.968001h-139.611637a23.295272 23.295272 0 0 1 0-46.558545h139.611637a23.295272 23.295272 0 0 1 0 46.558545z m0-977.409456h-139.611637a23.295272 23.295272 0 0 1 0-46.558545h139.611637a23.295272 23.295272 0 0 1 0 46.558545z m-26.143183 418.86691a46.526546 46.526546 0 1 1 0 93.117091h-139.643636v139.611637a46.558545 46.558545 0 0 1-93.085092 0v-139.611637h-139.611637a46.558545 46.558545 0 0 1 0-93.117091h139.611637v-139.611637a46.526546 46.526546 0 1 1 93.117091 0v139.611637h139.611637z m-253.112091-418.86691H302.550545a23.295272 23.295272 0 0 1 0-46.558545h139.611637a23.295272 23.295272 0 0 1 0 46.558545zM162.906909 1023.968001H23.263273A23.295272 23.295272 0 0 1 0 1000.704728v-139.643636a23.295272 23.295272 0 0 1 46.558545 0v116.348364H162.87491a23.295272 23.295272 0 0 1 0 46.558545z m0-977.409456H46.558545V162.87491A23.295272 23.295272 0 0 1 0 162.87491V23.263273C0 10.431674 10.431674 0 23.263273 0h139.643636a23.295272 23.295272 0 0 1 0 46.558545zM23.263273 279.255273c12.863598 0 23.295272 10.431674 23.295272 23.295272v139.611637a23.295272 23.295272 0 0 1-46.558545 0V302.550545c0-12.863598 10.431674-23.295272 23.263273-23.295272z m0 279.287273c12.863598 0 23.295272 10.399675 23.295272 23.263273v139.611637a23.295272 23.295272 0 0 1-46.558545 0v-139.611637c0-12.863598 10.431674-23.263273 23.263273-23.263273z m279.287272 418.86691h139.611637a23.295272 23.295272 0 0 1 0 46.558545H302.550545a23.295272 23.295272 0 0 1 0-46.558545z\" /></symbol>\n<symbol id=\"icon-book\" width=\"200px\" height=\"168.84px\" viewBox=\"0 0 1213 1024\" ><path d=\"M1211.58163 124.09363s-68.645926-57.685333-138.808889-88.064c-76.382815-37.05363-184.32-35.346963-184.32-35.346963s-76.003556-5.688889-153.941334 31.478518a658.773333 658.773333 0 0 0-135.471407 87.684741S519.585185 58.405926 449.308444 26.244741C379.031704-5.95437 277.617778 0.682667 277.617778 0.682667S181.172148 5.688889 119.125333 33.867852C57.002667 62.084741 0 129.21363 0 129.21363V994.797037s87.722667-76.724148 140.060444-98.304 134.181926-20.859259 134.181926-20.859259 98.076444 11.908741 156.520297 35.764148c58.405926 23.893333 168.239407 112.336593 168.239407 112.336593s70.011259-75.472593 126.217482-103.80326c95.269926-49.796741 189.743407-42.590815 189.743407-42.590815s58.026667 2.578963 138.808889 33.223112c73.424593 27.83763 159.250963 85.940148 159.250963 85.940148l-1.517037-872.410074zM569.192296 928.426667s-150.262519-120.187259-294.912-117.456593c-136.305778 2.541037-188.453926 37.432889-223.762963 73.197037 1.251556-42.097778-0.644741-723.512889-0.64474-723.512889s52.337778-95.269926 229.072592-102.930963c150.186667-12.781037 279.74163 94.435556 287.706074 114.915556 3.792593 26.775704 2.541037 755.787852 2.541037 755.787852z m586.827852-28.065186c-35.309037-35.764148-129.972148-89.391407-266.277926-91.932444-144.649481-2.730667-258.503111 121.287111-258.503111 121.287111s-1.289481-729.012148 2.503111-755.825778c12.629333-20.404148 111.085037-122.538667 287.744-114.915555 153.144889 6.750815 236.506074 100.617481 236.506074 100.617481s-1.820444 698.974815-1.972148 740.73126z\" /></symbol>\n<symbol id=\"icon-cup\" width=\"200px\" height=\"200.00px\" viewBox=\"0 0 1024 1024\" ><path d=\"M257.613576 557.676606a17.811394 17.811394 0 0 1-5.306182-0.806788l-29.416727-8.998788a18.059636 18.059636 0 0 1-4.468364-2.016969C78.072242 456.921212 10.053818 372.70497 16.259879 295.501576 23.024485 210.944 115.246545 170.790788 119.156364 169.115152a18.214788 18.214788 0 0 1 7.136969-1.458425h17.873455c9.867636 0 17.997576 7.881697 18.369939 17.842425 5.740606 141.28097 110.312727 342.884848 111.336728 344.901818a18.742303 18.742303 0 0 1-2.048 20.48 18.307879 18.307879 0 0 1-14.211879 6.826666zM127.069091 206.506667c-18.307879 9.557333-70.128485 40.92897-74.162424 92.16-4.499394 58.212848 52.844606 128.341333 166.198303 203.465697-30.471758-65.784242-82.354424-190.526061-92.035879-295.625697z m652.443151 344.622545a18.307879 18.307879 0 0 1-13.498181-5.957818 18.742303 18.742303 0 0 1-3.227152-20.355879c0.930909-2.07903 93.835636-209.423515 91.477333-350.797576a18.525091 18.525091 0 0 1 17.34594-18.897454l17.811394-1.024a18.959515 18.959515 0 0 1 7.23006 1.024c4.002909 1.458424 98.33503 36.150303 109.909334 120.180363 10.581333 76.737939-52.503273 164.770909-187.547152 261.709576a18.618182 18.618182 0 0 1-4.313212 2.296243l-28.858182 10.705454a17.935515 17.935515 0 0 1-6.330182 1.117091zM890.88 192.915394c-3.692606 105.472-48.345212 233.006545-75.031273 300.466424 108.885333-81.578667 162.133333-154.903273 154.282667-212.774788-6.888727-50.889697-60.38497-79.189333-79.251394-87.691636z\" /><path d=\"M511.100121 737.900606c-221.059879 0-400.911515-300.807758-400.911515-670.533818 0-13.312 0.279273-26.499879 0.713697-39.594667a27.741091 27.741091 0 0 1 27.61697-26.934303h745.161697c14.894545 0 27.089455 11.915636 27.585939 26.934303 0.434424 13.094788 0.744727 26.282667 0.744727 39.594667 0 369.726061-179.851636 670.533818-400.911515 670.533818zM165.453576 56.630303l-0.062061 10.736485c0 338.97503 155.089455 614.710303 345.708606 614.710303s345.708606-275.735273 345.708606-614.710303c0-3.599515 0-7.13697-0.06206-10.736485H165.453576z\" /><path d=\"M579.025455 602.049939a18.649212 18.649212 0 0 1-7.230061-35.684848c122.352485-53.030788 156.082424-206.041212 156.392727-207.561697a18.46303 18.46303 0 0 1 21.845334-14.30497 18.618182 18.618182 0 0 1 14.180848 22.031515c-1.458424 7.043879-37.794909 173.304242-177.958788 233.999516a17.935515 17.935515 0 0 1-7.23006 1.520484z m-67.925334 272.32194c-15.235879 0-27.61697-10.550303-27.616969-23.583031v-145.097696c0-13.032727 12.381091-23.58303 27.616969-23.583031s27.61697 10.550303 27.61697 23.583031v145.097696c0 13.032727-12.381091 23.58303-27.61697 23.583031z\" /><path d=\"M747.675152 1023.875879H287.961212a27.772121 27.772121 0 0 1-27.61697-27.927273c0-92.966788 113.105455-165.825939 257.458425-165.825939 144.384 0 257.458424 72.859152 257.458424 165.856969a27.772121 27.772121 0 0 1-27.61697 27.896243zM322.466909 968.083394h390.733576c-23.365818-46.669576-103.39297-82.168242-195.366788-82.168242-91.973818 0-172.00097 35.498667-195.366788 82.168242z\" /></symbol>\n<symbol id=\"icon-heart\" width=\"200px\" height=\"187.55px\" viewBox=\"0 0 1092 1024\" ><path d=\"M1090.321067 305.732267c-15.906133-176.64-140.0832-304.810667-295.5264-304.810667-103.5264 0-198.382933 56.081067-251.733334 145.988267C490.1888 55.876267 399.291733 0.9216 297.3696 0.9216 141.9264 0.9216 17.749333 129.092267 1.8432 305.664c-1.262933 7.850667-6.485333 48.878933 9.284267 115.848533 22.596267 96.597333 74.922667 184.388267 151.210666 253.952l380.450134 347.477334 387.037866-347.477334c76.288-69.563733 128.580267-157.354667 151.210667-253.952 15.7696-66.9696 10.581333-108.032 9.284267-115.780266z m-50.176 106.052266c-20.650667 88.2688-68.608 168.618667-138.4448 232.2432L543.061333 966.109867 190.5664 644.096c-69.973333-63.7952-117.896533-144.110933-138.581333-232.3456-14.848-63.351467-8.704-99.157333-8.704-99.328l0.3072-2.1504c13.653333-154.794667 120.354133-267.093333 253.781333-267.093333 98.440533 0 185.105067 60.893867 226.269867 158.856533l19.319466 46.216533 19.319467-46.216533c40.482133-96.4608 131.754667-158.8224 232.516267-158.8224 133.393067 0 240.128 112.298667 254.0544 269.038933 0.068267 0.341333 6.212267 36.181333-8.704 99.498667z\" /><path d=\"M336.0768 129.467733c-115.848533 0-210.056533 94.8224-210.056533 211.387734 0 11.6736 9.4208 21.162667 21.026133 21.162666 11.605333 0 20.992-9.489067 20.992-21.162666 0-93.2864 75.3664-169.130667 168.0384-169.130667 11.605333 0 20.992-9.454933 20.992-21.128533a21.060267 21.060267 0 0 0-20.992-21.162667z\" /></symbol>\n<symbol id=\"icon-id\" width=\"200px\" height=\"156.34px\" viewBox=\"0 0 1310 1024\" ><path d=\"M370.4832 464.52736c-82.82112 0-150.15936-66.68288-150.15936-148.6848 0-81.92 67.33824-148.60288 150.15936-148.60288 82.78016 0 150.15936 66.68288 150.15936 148.64384 0 81.92-67.3792 148.64384-150.15936 148.64384z m0-245.67808c-54.0672 0-98.01728 43.54048-98.01728 97.03424 0 53.49376 43.95008 97.03424 98.01728 97.03424 54.02624 0 97.97632-43.54048 97.97632-97.0752 0-53.4528-43.95008-96.99328-97.97632-96.99328z m218.27584 410.29632H536.576c0-90.68544-74.5472-164.4544-166.13376-164.4544-91.62752 0-166.13376 73.728-166.13376 164.4544H152.20736c0-119.1936 97.8944-216.10496 218.27584-216.10496 120.34048 0 218.27584 96.95232 218.27584 216.10496z m637.7472 394.15808H84.1728c-45.6704 0-82.86208-36.864-82.86208-82.08384V82.86208C1.31072 37.60128 38.5024 0.77824 84.1728 0.77824h1142.3744c45.6704 0 82.86208 36.864 82.86208 82.08384v858.35776a82.61632 82.61632 0 0 1-82.90304 82.08384zM84.1728 52.4288a30.59712 30.59712 0 0 0-30.72 30.43328v858.35776c0 16.7936 13.80352 30.43328 30.72 30.43328h1142.3744c16.91648 0 30.72-13.68064 30.72-30.43328V82.86208a30.63808 30.63808 0 0 0-30.72-30.43328H84.13184z m643.60448 206.97088h410.29632v51.6096H727.77728v-51.6096z m0 247.07072h410.29632v51.6096H727.77728v-51.6096zM151.01952 742.89152h987.05408v51.6096H151.01952v-51.6096z\" /></symbol>\n<symbol id=\"icon-phone\" width=\"200px\" height=\"200.00px\" viewBox=\"0 0 1024 1024\" ><path d=\"M197.632381 41.178403c37.763833 0 140.877405 98.769335 172.435185 165.174103 7.136961 14.956588 9.464231 27.772088 5.740599 31.123356L330.84531 278.342722c-32.116325 29.23051-49.182971 59.981503-50.765514 91.353101-1.644604 31.55778 12.319015 63.363802 41.363344 94.518189l242.532555 260.002594c30.44069 32.7059 61.657137 48.562365 95.356005 48.562365 31.216447 0 61.688168-13.901559 93.152857-42.573524l44.838734-40.835829c1.17915-1.086059 2.761694-1.489453 4.995872-1.644604 37.794863 0 128.930753 90.949708 155.399569 146.773155 7.447264 15.670284 9.464231 28.423723 5.213085 32.271476l-44.838733 40.773769c-44.869764 40.835829-95.200854 65.256648-149.379698 72.393609a253.548299 253.548299 0 0 1-33.543717 2.203149c-87.319167 0-175.786454-43.28722-249.110971-121.855852L161.358001 512.372984C26.376346 367.647826 21.597685 199.184515 149.101046 83.224413l44.931824-40.835829a5.461327 5.461327 0 0 1 3.009936-1.14812l0.589575-0.062061z m0-41.177162a47.476306 47.476306 0 0 0-32.054264 12.163864L120.801444 52.907844c-143.887341 130.823599-139.977527 326.655604 9.836594 487.299288l324.638637 348.097517c81.392386 87.288137 181.527053 135.198866 279.799903 135.198867 13.063742 0 26.127483-0.837817 39.098135-2.575512 62.929378-8.285081 120.862884-36.21232 172.217973-82.97493l44.838733-40.773769c13.498165-12.225925 25.227606-36.057168 4.344237-80.120145-28.299602-59.485019-128.992813-170.511308-193.163402-170.511309a48.438244 48.438244 0 0 0-33.202384 12.505197l-45.024915 40.990981c-23.055487 20.945429-44.187098 31.650871-64.853255 31.650871-21.535004 0-42.511464-11.605319-64.542952-35.343473l-242.625645-260.002593c-21.224702-22.776215-31.464689-44.46637-30.37863-64.511922 0.992968-20.386884 13.560226-41.580556 37.36044-63.270711l44.869763-40.742739c13.218893-12.008713 24.54494-35.436563 3.816723-78.972025C376.894224 123.687879 263.044181 0.001241 197.663411 0.001241z\" /></symbol>\n<symbol id=\"icon-work\" width=\"200px\" height=\"181.40px\" viewBox=\"0 0 1129 1024\" ><path d=\"M971.74069 178.811586H790.951724v-66.736552c0-62.252138-49.716966-111.192276-112.993103-111.192275h-225.986207c-63.276138 0-112.993103 48.940138-112.993104 111.227586v66.701241H158.190345C70.055724 178.811586 0 247.737379 0 334.494897v533.715862c0 86.757517 70.055724 155.68331 158.190345 155.68331h813.550345c88.134621 0 158.190345-68.925793 158.190344-155.68331V334.494897c0-86.757517-72.315586-155.718621-158.190344-155.718621z m-587.564138-66.736552c0-37.782069 29.378207-66.701241 67.795862-66.701241h225.986207c38.417655 0 67.795862 28.919172 67.795862 66.736552v66.701241H384.176552v-66.736552z m-225.986207 111.227587h813.550345c63.276138 0 112.993103 48.904828 112.993103 111.192276v206.812689L564.965517 748.120276 45.197241 541.307586V334.494897c0-62.287448 49.716966-111.227586 112.993104-111.227587z m813.550345 756.100413H158.190345c-63.276138 0-112.993103-48.904828-112.993104-111.192275v-277.963035L564.965517 797.060414l519.768276-206.81269v277.963035c0 60.027586-51.976828 111.227586-112.993103 111.227586z\" /></symbol>\n</svg>");

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_reset_scss__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_reset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_reset_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// 导入路由








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// 这里定义了两个全局组件 Hello 和 Jack
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router___default.a, // 引入路由
  template: '<App />',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_path__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_path__);





// const store = new Vuex.Store({
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {

    count: 0,
    selected: 'profile',
    user: {
      id: '',
      username: ''
    },

    icon: ['id', 'work', 'book', 'heart', 'cup', 'phone'],

    resume: {
      config: [{ title: '个人信息', field: 'profile', icon: 'id' }, { title: '工作经历', field: 'workHistory', icon: 'work' }, { title: '项目经历', field: 'projects', icon: 'heart' }, { title: '学习经历', field: 'studyHistory', icon: 'book' }, { title: '获奖经历', field: 'awards', icon: 'cup' }, { title: '联系方式', field: 'contact', icon: 'phone' }],
      profile: {
        name: '',
        title: '',
        city: '',
        birth: ''
      },
      workHistory: [{ company: '', duration: '', content: '' }],
      studyHistory: [{ school: '', duration: '', degree: '' }],
      projects: [{ name: '', duration: '', content: '' }],
      awards: [{ name: '' }],
      contact: {
        phone: '', email: '', wechat: '', qq: ''
      }
    }
  },
  mutations: {
    initState: function initState(state, payload) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, payload);
    },
    switchTab: function switchTab(state, payload) {
      state.selected = payload;
      localStorage.setItem('state', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state));
    },
    updateResume: function updateResume(state, _ref) {
      var path = _ref.path,
          value = _ref.value;

      __WEBPACK_IMPORTED_MODULE_4_object_path___default.a.set(state.resume, path, value);
      localStorage.setItem('state', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state));
    },
    addFieldItem: function addFieldItem(state, _ref2) {
      var path = _ref2.path;

      var newItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.resume[path][0]));
      for (var key in newItem) {
        newItem[key] = '';
      }
      __WEBPACK_IMPORTED_MODULE_4_object_path___default.a.push(state.resume, path, newItem);
      localStorage.setItem('state', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state));
    },
    removeFieldItem: function removeFieldItem(state, _ref3) {
      var path = _ref3.path,
          index = _ref3.index;

      state.resume[path].splice(index, 1);
      // let newItem = JSON.parse(JSON.stringify(state.resume[path][0]));
      // for (let key in newItem) {
      //   newItem[key] = '';
      // }
      // objectPath.push(state.resume,  path,  newItem);
      localStorage.setItem('state', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state));
    },
    setUser: function setUser(state, payload) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.user, payload);
    },
    removeUser: function removeUser(state) {
      state.user.id = '';
    }
  }
}));

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(188),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(189),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(170)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(191),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3977065a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(172)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(193),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(194),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(190),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(174)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(195),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(187),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm._v("\n    Resumer\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.logined) ? _c('div', {
    staticClass: "userActions"
  }, [_c('span', {
    staticClass: "welcome"
  }, [_vm._v("您好，" + _vm._s(_vm.user.username))]), _vm._v(" "), _c('a', {
    staticClass: "button is-info is-outlined",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signOut.apply(null, arguments)
      }
    }
  }, [_vm._v("登出")])]) : _c('div', {
    staticClass: "userActions"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signUpDialogVisible = true
      }
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signInDialogVisible = true
      }
    }
  }, [_vm._v("登录")])]), _vm._v(" "), _c('div', {
    staticClass: "userActions"
  }, [_c('a', {
    staticClass: "button is-primary is-outlined"
  }, [_vm._v("保存")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.preview
    }
  }, [_vm._v("预览")])])]), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "注册",
      "visible": _vm.signUpDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signUpDialogVisible = false
      }
    }
  }, [_c('SignUpForm', {
    on: {
      "success": function($event) {
        return _vm.signIn($event)
      },
      "cancel": _vm.cancel
    }
  })], 1), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "登录",
      "visible": _vm.signInDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signInDialogVisible = false
      }
    }
  }, [_c('SignInForm', {
    on: {
      "success": function($event) {
        return _vm.signIn($event)
      },
      "cancel": _vm.cancel
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-form', [_vm._l((_vm.items), function(work, index) {
    return _c('div', {
      key: index,
      staticClass: "container"
    }, [_vm._l((_vm.keys), function(key) {
      return _c('el-form-item', {
        key: key,
        attrs: {
          "label": _vm.labels[key] || key
        }
      }, [_c('el-input', {
        model: {
          value: (work[key]),
          callback: function($$v) {
            _vm.$set(work, key, $$v)
          },
          expression: "work[key]"
        }
      })], 1)
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          return _vm.removeItems(index)
        }
      }
    })], 2)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addItems()
      }
    }
  }, [_vm._v("添加一项")])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    }
  }, [_c('nav', [_c('ol', _vm._l((_vm.resume.config), function(item, index) {
    return _c('li', {
      class: {
        active: item.field === _vm.selected
      },
      on: {
        "click": function($event) {
          _vm.selected = item.field
        }
      }
    }, [_c('svg', {
      staticClass: "icon"
    }, [_c('use', {
      attrs: {
        "xlink:href": ("#icon-" + (item.icon))
      }
    })])])
  }), 0)]), _vm._v(" "), _c('ol', {
    staticClass: "panels"
  }, _vm._l((_vm.resume.config), function(item) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.field === _vm.selected),
        expression: "item.field === selected"
      }]
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (_vm.resume[item.field] instanceof Array) ? _c('div', [_vm._l((_vm.resume[item.field]), function(subitem, i) {
      return _c('div', {
        staticClass: "subitem"
      }, [_c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.resume[item.field].length > 1),
          expression: "resume[item.field].length > 1"
        }],
        staticClass: "el-icon-circle-close close-item",
        on: {
          "click": function($event) {
            return _vm.removeItem(("" + (item.field)), i)
          }
        }
      }), _vm._v(" "), _vm._l((subitem), function(value, key) {
        return (key !== 'title') ? _c('div', {
          staticClass: "resumeField"
        }, [_c('p', {}, [_vm._v(" " + _vm._s(key) + " ")]), _vm._v(" "), _c('div', {
          staticClass: "field"
        }, [_c('div', {
          staticClass: "control"
        }, [_c('input', {
          staticClass: "input text",
          attrs: {
            "type": "text",
            "placeholder": "input"
          },
          domProps: {
            "value": value
          },
          on: {
            "input": function($event) {
              return _vm.changeResumeField(((item.field) + "." + i + "." + key), $event.target.value)
            }
          }
        })])])]) : _vm._e()
      }), _vm._v(" "), _c('hr')], 2)
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(("" + (item.field)))
        }
      }
    }, [_vm._v("添加一项")])], 2) : _vm._l((_vm.resume[item.field]), function(value, key) {
      return _c('div', {
        staticClass: "resumeField"
      }, [_c('p', {}, [_vm._v(" " + _vm._s(key) + " ")]), _vm._v(" "), _c('div', {
        staticClass: "field"
      }, [_c('div', {
        staticClass: "control"
      }, [_c('input', {
        staticClass: "input text",
        attrs: {
          "type": "text",
          "placeholder": "input"
        },
        domProps: {
          "value": value
        },
        on: {
          "input": function($event) {
            return _vm.changeResumeField(((item.field) + "." + key), $event.target.value)
          }
        }
      })])])])
    })], 2)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "signInActions"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel.apply(null, arguments)
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('button', {
    staticClass: "active",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signIn.apply(null, arguments)
      }
    }
  }, [_vm._v("登 录")])])])])
},staticRenderFns: []}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "dialogWrapper"
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('header', [_vm._v("\n          " + _vm._s(_vm.title) + "\n          "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('main', [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      previewMode: _vm.previewMode
    },
    attrs: {
      "id": "app"
    }
  }, [_c('Topbar', {
    staticClass: "topbar",
    on: {
      "preview": _vm.preview
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('Editor', {
    staticClass: "editor"
  }), _vm._v(" "), _c('Preview', {
    staticClass: "preview"
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "exitPreview"
    },
    on: {
      "click": _vm.exitPreview
    }
  }, [_vm._v("退出预览")]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "preview"
    }
  }, [_c('h3', {
    staticClass: "title is-3"
  }, [_vm._v(_vm._s(_vm.resume.profile.name || "请填写姓名"))]), _vm._v(" "), _c('h4', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.resume.profile.title || "请输入职位"))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.resume.profile.city || "请填写城市") + "   " + _vm._s(_vm.resume.profile.birth || "请填写出生年月"))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.filter(_vm.resume.workHistory).length > 0) ? _c('section', [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("工作经历")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.workHistory)), function(work) {
    return _c('li', {
      staticClass: "part"
    }, [_c('p', {
      staticClass: "is-large"
    }, [_vm._v(_vm._s(work.company) + "  " + _vm._s(work.duration))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v(_vm._s(work.content))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.filter(_vm.resume.projects).length > 0) ? _c('section', [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("项目经历")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.projects)), function(project) {
    return _c('li', [_c('p', {
      staticClass: "is-large"
    }, [_vm._v(_vm._s(project.name) + " " + _vm._s(project.duration))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(project.content))]), _vm._v(" "), _c('hr')])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.filter(_vm.resume.studyHistory).length > 0) ? _c('section', [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("学习经历")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.studyHistory)), function(study) {
    return _c('li', [_c('p', {
      staticClass: "is-large"
    }, [_vm._v(_vm._s(study.school) + " " + _vm._s(study.duration))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(study.degree))]), _vm._v(" "), _c('hr')])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.filter(_vm.resume.awards).length > 0) ? _c('section', [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("获奖情况")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.awards)), function(award) {
    return _c('li', [_vm._v("\n          " + _vm._s(award.name) + "\n          "), _c('hr')])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.resume.contact)) ? _c('section', {
    staticClass: "contact"
  }, [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resume.contact.phone || "请输入电话号码"))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resume.contact.email || "请输入邮箱"))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resume.contact.wechat || "请输入微信"))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resume.contact.qq || "请输入QQ"))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("手机号码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("电子邮箱")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("微信")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("QQ")])])
}]}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("个人信息")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, _vm._l((_vm.resume.profile), function(value, key) {
    return _c('div', {
      staticClass: "control",
      attrs: {
        "label": _vm.titles[key]
      }
    }, [_c('input', {
      staticClass: "input text",
      attrs: {
        "type": "text",
        "placeholder": "input"
      },
      domProps: {
        "value": value
      },
      on: {
        "input": function($event) {
          return _vm.changeResumeField('profile', key, $event.target.value)
        }
      }
    })])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "signInActions"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel.apply(null, arguments)
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('button', {
    staticClass: "active",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signUp.apply(null, arguments)
      }
    }
  }, [_vm._v("注 册")])])])])
},staticRenderFns: []}

/***/ })
],[108]);


// WEBPACK FOOTER //
// static/js/app.f4f7ee52b22bfb3df6f3.js